"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var _Toggle = require("../../../components/Toggle");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AvailabilityForNewPatients = function AvailabilityForNewPatients(_ref) {
  var HeadingComponent = _ref.HeadingComponent,
    description = _ref.description,
    _ref$clinicianId = _ref.clinicianId,
    clinicianId = _ref$clinicianId === void 0 ? 'me' : _ref$clinicianId;
  var _useUpdateAvailabilit = (0, _utils.useUpdateAvailabilityForNewPatients)(clinicianId),
    available = _useUpdateAvailabilit.available,
    loadingAvailability = _useUpdateAvailabilit.loadingAvailability,
    updateAvailabilityPreferences = _useUpdateAvailabilit.updateAvailabilityPreferences;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "max-w-[700px]"
  }, HeadingComponent, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row w-full"
  }, description && /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full"
  }, description), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Toggle.Toggle, {
    checked: available,
    loading: loadingAvailability,
    onChange: updateAvailabilityPreferences
  }))));
};
var _default = AvailabilityForNewPatients;
exports.default = _default;